import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import React from 'react';
import classNames from 'classnames';
import devWarning from '../_utils/devwarning';

var getAllMarkPoints = function getAllMarkPoints(marks, dots, step, min, max) {
  var _context, _context2;

  devWarning(dots ? step > 0 : true, 'slider', '`Slider[step]` should be a positive number in order to make Slider[dots] work.');

  var points = _sortInstanceProperty(_context = _mapInstanceProperty(_context2 = _Object$keys(marks)).call(_context2, parseFloat)).call(_context, function (a, b) {
    return a - b;
  });

  if (dots && step) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }

  return points;
};

function steps(props) {
  var _context3;

  var marks = props.marks,
      prefixCls = props.prefixCls,
      vertical = props.vertical,
      reverse = props.reverse,
      dots = props.dots,
      step = props.step,
      min = props.min,
      max = props.max,
      bound = props.bound;
  var range = max - min;

  var elements = _mapInstanceProperty(_context3 = getAllMarkPoints(marks, dots, step, min, max)).call(_context3, function (point) {
    var _classNames;

    var isActived = bound >= point;
    var offset = "".concat(Math.abs(point - min) / range * 100, "%");
    var style = vertical ? _defineProperty({}, reverse ? 'top' : 'bottom', offset) : _defineProperty({}, reverse ? 'right' : 'left', offset);
    var markPointClass = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-dot"), true), _defineProperty(_classNames, "".concat(prefixCls, "-dot-actived"), isActived), _classNames));
    return /*#__PURE__*/React.createElement("span", {
      className: markPointClass,
      key: point,
      style: style
    });
  });

  var stepClass = classNames("".concat(prefixCls, "-step"), _defineProperty({}, "".concat(prefixCls, "-reverse"), reverse));
  return /*#__PURE__*/React.createElement("div", {
    className: stepClass
  }, elements);
}

export default steps;